import React from 'react'

import { observer } from 'mobx-react'

import { useStores } from 'stores'
import ContentLoader from 'common/ContentLoader'

import PurchaseOrderTable from './PurchaseOrderTable'

export default observer(({ activated, caseId, caseCurrency }) => {
  const { pageResourceStore, salesInvoiceStore } = useStores()

  const {
    PageResource: { case: resource = {} },
  } = pageResourceStore
  const {
    Table: {
      data: { salesInvoice: { purchaseOrderBlock = [] } = {} },
      loading,
    },
  } = salesInvoiceStore

  React.useEffect(() => activated && salesInvoiceStore.fetchTable(caseId), [salesInvoiceStore, caseId, activated])

  return (
    <div className="position-relative">
      <ContentLoader show={loading} />
      {!!purchaseOrderBlock.length &&
        purchaseOrderBlock.map((purchaseOrder, index) => (
          <div key={index} className="purchase-order-block margin-bot-20 col-12">
            <PurchaseOrderTable resource={resource} purchaseOrderItem={purchaseOrder} caseCurrency={caseCurrency}/>
          </div>
        ))}
    </div>
  )
})
